<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>
    <lsn-table :data="invoices" class="sl-due-invoice-table">
        <!-- Embedded Table Header Caption -->
        <template #subtable-caption>
            <slot name="subtable-caption" />
        </template>

        <!-- Table Header -->
        <template #header>
            <lsn-table-cell class="sl-invoice__date">
                {{ $t('invoicing.table.headers.date') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__reference">
                {{ $t('invoicing.table.headers.reference') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__status">
                {{ $t('invoicing.table.headers.status') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__price">
                {{ $t('invoicing.table.headers.amount') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__balance">
                {{ $t('invoicing.table.headers.balance') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__currency">
                {{ $t('invoicing.table.headers.currency') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__due-date">
                {{ $t('invoicing.table.headers.due_date') }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-invoice__actions" />
        </template>

        <!-- Table Body -->
        <template #summary="{ item }">
            <due-invoice-line-summary :invoice="item" />
        </template>

        <template #details="{ item }">
            <invoice-line-details :invoice="item" />
        </template>
    </lsn-table>
</template>


<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
import LsnTable              from '@/components/LsnTable/LsnTable.vue';
import LsnTableCell          from '@/components/LsnTable/LsnTableCell.vue';
import DueInvoiceLineSummary from '@/components/invoice/DueInvoiceLineSummary.vue';
import InvoiceLineDetails    from '@/components/invoice/InvoiceLineDetails.vue';

export default
{
    name: 'DueInvoiceTable',

    components:
    {
        LsnTable,
        LsnTableCell,
        DueInvoiceLineSummary,
        InvoiceLineDetails,
    },

    props:
    {
        invoices:
        {
            type:     Object,
            required: true,
        },
    },
};
</script>


<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style>
@reference "#main.css";

.sl-invoice__price,
.sl-invoice__balance
{
    @apply text-right;
}

.sl-due-invoice-table .sl-invoice__balance
{
    @apply font-bold;
}

.sl-invoice__reference,
.sl-invoice__status,
.sl-invoice__currency,
.sl-invoice__due-date,
.sl-invoice__actions
{
    @apply text-center;
}
</style>
